// 集合列表页js
(function () {
  var currentSymbol =  WS.site.symbol;
  var filterData = null;
  var collectionPageParams = {};
  var curCollctionId = $('#collection-conatiner').attr('collectionId');
  var curCollctionHandle = $('#collection-conatiner').attr('handle');
  var reportData = '';

  function getCollectionTrackHandle(root) {
    if (root && root.getAttribute) {
      var handle = root.getAttribute('data-collection-handle');
      if (handle) return handle;
    }
    return curCollctionHandle || $('#collection-conatiner').attr('handle') || '';
  }

  function getTrackText(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function getCollectionFilterTrackingData(params) {
    params = params || {};
    var price = '';
    if (params.priceRange && params.priceRange.length) {
      var range = params.priceRange[0] || {};
      price = [range.startPrice, range.endPrice].filter(function(value) {
        return value !== undefined && value !== null && value !== '';
      }).join('-');
    }
    return {
      size: (params.sizes || []).join(','),
      color: (params.colorFilters || []).map(function(item) { return item.value; }).filter(Boolean).join(','),
      productType: (params.productTypes || []).join(','),
      price: price
    };
  }

  function hasCollectionFilterTrackingData(data) {
    return !!(data && (data.size || data.color || data.productType || data.price));
  }

  function trackCollectionClick(eventName, data) {
    if (!eventName || !window.WS || !WS.stat || !WS.ui || !WS.ui.reportType) return;
    data = data || {};
    var payload = {
      eid: WS.ui.reportType['click'],
      ext1: eventName,
      ext2: data.collectionHandle || getCollectionTrackHandle()
    };
    if (data.sortType || data.size) payload.ext3 = data.sortType || data.size;
    if (data.color) payload.ext4 = data.color;
    if (data.productType) payload.ext5 = data.productType;
    if (data.price) payload.ext6 = data.price;
    WS.stat(payload);
  }

  // 从 URL 回填筛选/排序参数，支持 Free Gift 的 ADD MORE 跳转后直接按价格和排序加载集合。
  function initCollectionParamsFromUrl() {
    try {
      if (typeof URLSearchParams === 'undefined') return;
      var searchParams = new URLSearchParams(window.location.search || '');
      if (!searchParams.toString()) return;
      var params = {
        colorFilters: [],
        sizes: [],
        productTypes: [],
        priceRange: [],
        orderBy: ''
      };
      var hasParams = false;
      var sortBy = searchParams.get('sort_by') || '';
      if (sortBy) {
        params.orderBy = sortBy;
        hasParams = true;
      }
      var priceStart = searchParams.get('filter.v.price.gte') || '';
      var priceEnd = searchParams.get('filter.v.price.lte') || '';
      if (priceStart || priceEnd) {
        params.priceRange = [{
          currency: currentSymbol || '',
          startPrice: priceStart,
          endPrice: priceEnd
        }];
        hasParams = true;
      }
      searchParams.getAll('filter.v.option.size').forEach(function(value) {
        if (!value) return;
        params.sizes.push(value);
        hasParams = true;
      });
      searchParams.getAll('filter.p.product_type').forEach(function(value) {
        if (!value) return;
        params.productTypes.push(value);
        hasParams = true;
      });
      searchParams.forEach(function(value, key) {
        if (!value || !key) return;
        if (key === 'sort_by' || key === 'filter.v.price.gte' || key === 'filter.v.price.lte' || key === 'filter.v.option.size' || key === 'filter.p.product_type') return;
        // 颜色筛选的 Shopify 参数可能来自 taxonomy/metafield，key 不固定，按 color 做兜底识别。
        if (key.toLowerCase().indexOf('color') >= 0) {
          params.colorFilters.push({ param: key, value: value });
          hasParams = true;
        }
      });
      if (!hasParams) return;
      collectionPageParams = params;
      WS.setData('collectionPageParams', collectionPageParams);
    } catch (e) {}
  }

  // 底部单图片模块区域
  var bottomSingleImgHtml = `
    <div class="bottom-model-box">
      <p class="box-title title-center"><%= data.title %></p>
      <div class="box-img-only">
        <% for ( var item of data.appBanner ) { %>
          <a class="img-link" <% if (item.directUrl) { %>href="${WS.site.dir}<%= item.directUrl %>"<% } %>>
            <div class="img-box js-lazyload-img">
              <img src="<%= item.imgUrl %>" />
            </div>
          </a>
        <% } %>
      </div>
    </div>
  `;

  // 底部多图片模块区域
  var bottomMoreImgHtml = `
    <div class="bottom-model-box">
      <p class="box-title"><%= data.title %></p>
      <div class="box-img-list">
        <% for ( var item of data.appBanner ) { %>
          <a class="img-link" <% if (item.directUrl) { %>href="${WS.site.dir}<%= item.directUrl %>"<% } %>>
            <div class="img-box js-lazyload-img">
              <img src="<%= item.imgUrl %>" />
            </div>
          </a>
        <% } %>
      </div>
    </div>
  `;

  // 底部集合模块区域
  var bottomCollectionProductHtml = `
    <div class="bottom-model-box ws-featured-collection-sliderbox">
      <div class="ws-featured-collection-container">
        <p class="box-title"><%= data.title %></p>
        <div class="collection-listbox ws-featured-collection-listing" data-title="<%= data.collectionName %>">
          <div class="ws-featured-collection-product-list ws-product-list-row-4" data-list-type="<%= data.listType %>"></div>
        </div>
      </div>
    </div>
  `;

  // 集合列表方法
  var collectionPageFn = {
    /**
     * 子集合横滑指示条：沿用 Featured Collection 的比例计算方式。
     * 仅移动端且列表真实溢出时展示。
     */
    initSubcollectionsScrollbar: function() {
      var $modules = $('.ws-subcollections--scroll');
      if (!$modules.length) return;

      function updateModule(moduleEl) {
        var $module = $(moduleEl);
        var $track = $module.find('.ws-subcollections__track').first();
        var $bar = $module.find('.ws-subcollections__scrollbar').first();
        var $thumb = $bar.find('.ws-subcollections__scrollbar-thumb').first();
        if (!$track.length || !$bar.length || !$thumb.length) return;

        var isDesktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var trackEl = $track.get(0);
        var barEl = $bar.get(0);
        if (isDesktop || !trackEl || !barEl) {
          $bar.hide();
          return;
        }

        var scrollWidth = trackEl.scrollWidth || 0;
        var clientWidth = trackEl.clientWidth || 0;
        if (scrollWidth <= clientWidth + 1 || clientWidth <= 0) {
          $bar.hide();
          return;
        }

        $bar.show();
        var barWidth = barEl.clientWidth || 0;
        var ratio = clientWidth / scrollWidth;
        var minThumbWidth = 36;
        var thumbWidth = Math.max(Math.round(barWidth * ratio), minThumbWidth);
        thumbWidth = Math.min(thumbWidth, barWidth);
        $thumb.css({ width: thumbWidth + 'px' });

        var maxScroll = scrollWidth - clientWidth;
        var maxThumbMove = Math.max(barWidth - thumbWidth, 0);
        var left = maxScroll > 0 ? ((trackEl.scrollLeft || 0) / maxScroll) * maxThumbMove : 0;
        $thumb.css({ transform: 'translateX(' + left + 'px)' });
      }

      $modules.each(function() {
        var moduleEl = this;
        var $track = $(moduleEl).find('.ws-subcollections__track').first();
        $track
          .off('scroll.wsSubcollectionsScrollbar')
          .on('scroll.wsSubcollectionsScrollbar', function() {
            updateModule(moduleEl);
          });
        updateModule(moduleEl);
      });

      $(window)
        .off('resize.wsSubcollectionsScrollbar')
        .on('resize.wsSubcollectionsScrollbar', function() {
          $modules.each(function() {
            updateModule(this);
          });
        });
    },
    updateCollectionCount: function() {
      var countEl = $('.ws-collection-count');
      if (!countEl.length) return;
      var count = parseInt(countEl.attr('data-products-count'));
      var formatCount = WS.ui.numberWithDelimiter(count);
      var countText = count >= 1 ? `${formatCount} items` : `${formatCount} item`;
      countEl.text(countText);
    },
    reloadList: function() {
      WS.setData('collectionPageParams', collectionPageParams);
      $('.ws-maintop-popupbox-filter').hide();
      WS.ui.popupRecoveryScrollHandle();
      WS.ui.infiniteScroll.resetShopifyCollection();
    },
    /**
     * 将 GraphQL 获取的 filterData 渲染到 section westyle-collection-filters 的 data-ws-cf-dynamic 容器中
     * 有则展示，无则不展示，无默认值
     */
    renderFilterDataToSection: function() {
      if (!filterData) return;
      var container = document.querySelector('.ws-cf [data-ws-cf-dynamic]');
      if (!container) return;
      var collectionUrl = (document.querySelector('.ws-cf') && document.querySelector('.ws-cf').getAttribute('data-collection-url')) || (WS.site.dir + '/collections/' + (curCollctionHandle || ''));

      function esc(s) {
        if (s == null) return '';
        var div = document.createElement('div');
        div.textContent = s;
        return div.innerHTML;
      }

      var html = '';
      var querySep = collectionUrl.indexOf('?') >= 0 ? '&' : '?';
      // 选项类筛选用正确值：taxonomy 类（如 color-pattern）从 input JSON 提取 value；非 JSON 用 input；否则 label/id
      function getOptionValue(v) {
        var raw = (v.input != null && v.input !== '') ? v.input : null;
        if (typeof raw === 'string' && raw.charAt(0) !== '{') return raw;
        if (typeof raw === 'string' && raw.charAt(0) === '{') {
          try {
            var parsed = JSON.parse(raw);
            var tm = parsed && parsed.taxonomyMetafield;
            if (tm && tm.value != null) return String(tm.value);
          } catch (e) {}
        }
        return v.label || v.id || '';
      }

      function addPillGroup(filter, groupId, titleKey) {
        if (!filter || !filter.values || filter.values.length === 0) return;
        var param = filter.id || ('filter.v.option.' + (filter.label || '').toLowerCase().replace(/\s+/g, '_'));
        var title = filter.label || titleKey;
        title = title === '产品类型' ? 'Product Type' : title;
        html += '<section class="ws-cf__group" role="group" aria-labelledby="' + esc(groupId) + '"><h3 id="' + esc(groupId) + '" class="ws-cf__group-title">' + esc(title) + ':</h3><ul class="ws-cf__pills ws-cf__pills--' + title.toLowerCase().replace(/\s+/g, '-') + '" role="list">';
        filter.values.forEach(function(v) {
          var val = getOptionValue(v);
          if (val === '') return;
          var url = collectionUrl + querySep + param + '=' + encodeURIComponent(val);
          html += '<li><label class="ws-cf__pill" data-ws-cf-param="' + esc(param) + '" data-ws-cf-value="' + esc(val) + '"><input class="ws-cf__input" type="checkbox" value="' + esc(val) + '"' + (v.count === 0 ? ' disabled' : '') + '><span>' + esc(v.label || val) + (v.count === 0 ? ' (unavailable)' : '') + '</span></label></li>';
        });
        html += '</ul></section>';
      }

      function addColorGroup(filter, groupId) {
        if (!filter || !filter.values || filter.values.length === 0) return;
        var param = filter.id || 'filter.v.option.color';
        var title = filter.label || 'Color';
        html += '<section class="ws-cf__group" role="group" aria-labelledby="' + esc(groupId) + '"><h3 id="' + esc(groupId) + '" class="ws-cf__group-title">' + esc(title) + ':</h3><ul class="ws-cf__colors" role="list">';
        filter.values.forEach(function(v) {
          var val = getOptionValue(v);
          if (val === '') return;
          var url = collectionUrl + querySep + param + '=' + encodeURIComponent(val);
          var bgColor = (v.swatch && v.swatch.color) || '';
          var bgImg = (v.swatch && v.swatch.image && v.swatch.image.image && v.swatch.image.image.url) || '';
          var swatchStyle = '';
          if (bgColor) {
            swatchStyle = 'background-color:' + bgColor + ';';
          } else if (bgImg) {
            swatchStyle = 'background-image:url(' + bgImg + ');';
          }
          html += '<li><label class="ws-cf__color" data-ws-cf-param="' + esc(param) + '" data-ws-cf-value="' + esc(val) + '"><input class="ws-cf__input" type="checkbox" value="' + esc(val) + '"' + (v.count === 0 ? ' disabled' : '') + '><span class="ws-cf__color-swatch" style="' + esc(swatchStyle) + '" aria-hidden="true"></span><span class="ws-cf__color-label">' + esc(v.label || val) + (v.count === 0 ? ' (unavailable)' : '') + '</span></label></li>';
        });
        html += '</ul></section>';
      }
      
      if (filterData.sizeList && filterData.sizeList.values.length > 2) addPillGroup(filterData.sizeList, 'ws-cf-size-dynamic', 'Size');
      if (filterData.colorList && filterData.colorList.values.length > 2) addColorGroup(filterData.colorList, 'ws-cf-color-dynamic');
      if (filterData.productTypeList && filterData.productTypeList.values.length > 2) addPillGroup(filterData.productTypeList, 'ws-cf-product-type-dynamic', 'Product type');

      container.innerHTML = html;
    },
    handleFilterData: function(handleType, onReady) {
      if (filterData) {
        collectionPageFn.renderFilterDataToSection();
        onReady && onReady();
        return;
      }
      WS.ui.graphql({
        query: "query Facets($handle: String!, $first: Int!) { collection(handle: $handle) { handle products(first: $first) { filters { id label type presentation values { id label count input swatch { color image { id image { url altText } } } image { id image { url altText } } } } } } }",
        variables: { handle: curCollctionHandle, first: 10 }
      }).then(function(res) {
        var data = res.data;
        if (!data || !data.collection || !data.collection.products || !data.collection.products.filters) return;
        var filters = data.collection.products.filters;
        var colorList = filters.find(function(item) { return (item.id || '') === 'filter.v.t.shopify.color-pattern'; });
        var sizeList = filters.find(function(item) { return (item.label || '').toLowerCase() === 'size'; });
        var priceList = filters.find(function(item) { return (item.label || '').toLowerCase() === '价格' || (item.label || '').toLowerCase() === 'price'; });
        var productTypeList = filters.find(function(item) { return (item.label || '').toLowerCase() === '产品类型' || (item.label || '').toLowerCase() === 'product type'; });
        var sortList = filters.find(function(item) { return (item.label || '').toLowerCase() === 'sort'; });
        filterData = {
          colorList: colorList || null,
          sizeList: sizeList || null,
          priceList: priceList || null,
          productTypeList: productTypeList || null,
          sortList: sortList || null
        };
        collectionPageFn.renderFilterDataToSection();
        onReady && onReady();
      });
    },
    /**
     * 事件集合方法
     */
    initShortDescriptionHandle: function() {
      var self = this;
      if (!window.WS || !WS.ui || !WS.ui.initTextReadMore) return;
      WS.ui.initTextReadMore({
        blockSelector: '.js-collection-short-desc',
        wrapSelector: '.ws-collection__short-description__wrap',
        textSelector: '.ws-collection__short-description__text',
        readMoreSelector: '.ws-collection__short-description__read-more',
        collapseSelector: '.ws-collection__short-description__collapse',
        maxLines: 3,
        lineHeightFallbackMultiplier: 1.4,
        fullTextAttr: 'data-full-text'
      });
      if (WS.ui.bindTextReadMoreEvents) {
        WS.ui.bindTextReadMoreEvents({
          blockSelector: '.js-collection-short-desc',
          textSelector: '.ws-collection__short-description__text',
          readMoreSelector: '.ws-collection__short-description__read-more',
          collapseSelector: '.ws-collection__short-description__collapse',
          fullTextAttr: 'data-full-text',
          eventNamespace: 'wsShortDesc',
          resizeDelay: 180,
          onRecalc: function() {
            self.initShortDescriptionHandle();
          }
        });
      }
    },
    bindEvent: function () {
      $(document).on('click', '.collection-sub-module .collection-sub-desc_show-more-btn', function() {
        var descText = $(this).parents('.collection-sub-desc_text');
        var cls = 'limit-height';
        descText.removeClass(cls);
      });

      // 点击创建filter弹窗
      $(document).on('click', '.ws-list-filter-icon-btn', async function() {
        if (!document.querySelector('.ws-cf')) {
          trackCollectionClick('filter_icon');
        }
        // 创建弹窗
        // 判断是否已经存在弹窗，如果没有存在，创建弹窗内容，如果存在，则直接显示内容
        if ($('.ws-maintop-popupbox-filter').html()) {
          // 显示已有弹窗
          $('.ws-maintop-popupbox-filter').removeClass('hide-popup').show();
          WS.ui.popupNoScrollHandle();
        } else {
          collectionPageFn.handleFilterData(1);
        }
      });

      // 点击创建sort弹窗
      $(document).on('click', '.ws-list-sort-icon-btn', function() {
        if (!document.querySelector('.ws-cf')) {
          trackCollectionClick('sort_icon');
        }
        // 创建弹窗
        // 判断是否已经存在弹窗，如果没有存在，创建弹窗内容，如果存在，则直接显示内容
        if ($('.ws-maintop-popupbox-sort').html()) {
          // 显示已有弹窗
          $('.ws-maintop-popupbox-sort').removeClass('hide-popup').show()
        } else {
          collectionPageFn.handleFilterData(2);
        }
        // 禁止弹窗底部滚动方法
        WS.ui.popupNoScrollHandle();
      });

      // 点击icon关闭弹窗
      $(document).on("click", ".ws-maintop-popupbox .ws-icon-close",function () {
        // 恢复弹窗底部滚动方法
        WS.ui.popupRecoveryScrollHandle();
        // 隐藏弹窗
        $(this).parents(".ws-maintop-popupbox").hide();
      });
      
      // 空结果时 Remove All：清空筛选项并重新加载集合列表
      $(document).on('click', '.ws-empty-results__remove-all', function(e) {
        e.preventDefault();
        try {
          var collectionId = $('#collection-conatiner').attr('collectionId');
          var storageKey = collectionId ? ('ws-cf-state-' + collectionId) : 'ws-cf-state';
          window.sessionStorage && sessionStorage.removeItem(storageKey);
        } catch (err) {}
        var filterEl = document.querySelector('.ws-cf');
        if (filterEl) {
          filterEl.querySelectorAll('.ws-cf__pill--active').forEach(function(p) { p.classList.remove('ws-cf__pill--active'); });
          filterEl.querySelectorAll('.ws-cf__color--active').forEach(function(p) { p.classList.remove('ws-cf__color--active'); });
        }
        WS.setData('collectionPageParams', {});
        WS.ui.infiniteScroll && WS.ui.infiniteScroll.resetShopifyCollection && WS.ui.infiniteScroll.resetShopifyCollection();
        var $listing = $('#collection-conatiner').find('.js-infinite-scroll-listing');
        if ($listing.length) $listing.trigger('ws-trigger-load');
      });

      // 点击sort选项
      $(document).on('click', '.ws-maintop-popupbox-sort .ws-options-li', function() {
        var $this = $(this);
        var activeCls = 'ws-options-li-active';
        trackCollectionClick('sort_items', {
          sortType: getTrackText($this[0]) || $this.attr('data-value') || ''
        });
        $this.addClass(activeCls).siblings().removeClass(activeCls);
        setTimeout(function() {
          collectionPageParams = WS.getData('collectionPageParams') || {};
          collectionPageParams.orderBy = $this.attr('data-value');
          WS.setData('collectionPageParams', collectionPageParams);
          WS.ui.infiniteScroll.resetShopifyCollection();
          WS.ui.popupRecoveryScrollHandle();
          $this.parents(".ws-maintop-popupbox").hide();
        }, 0);
      });

      // 点击查看更多文案
      $(document).on('click', '.top-model-text-box', function() {
        // 判断模块显示状态
				if ($(this).find('.open-icon').hasClass('close-icon')) {
					// 隐藏模块
          $(this).find('.open-icon').removeClass('close-icon');
          $(this).find('.box-text').removeClass('box-text-show');
				} else {
					// 显示模块
          $(this).find('.open-icon').addClass('close-icon');
          $(this).find('.box-text').addClass('box-text-show');
				}
      });

      // 集合底部banner（单图）点击
      $(document).on('click', '.ws-collection-bottom-model .box-img-only .img-link', function() {
        var href = $(this).attr('href');
        // 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.collectionReportMap['clickBottomBannerCollection'],
          ext2: JSON.stringify(reportData || []),
          ext4: href,
        });
      });

      // 集合底部picture(多图）点击
      $(document).on('click', '.ws-collection-bottom-model .box-img-list .img-link', function() {
        var index = $(this).index();
        var href = $(this).attr('href');
        // 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.collectionReportMap['clickBottomPictureCollection'],
          ext2: JSON.stringify(reportData || []),
          ext3: `pos=${index+1}`,
          ext4: href,
        });
      });

      // 集合底部Recently Viewed模块商品点击
      $(document).on('click', '.ws-collection-bottom-model .ws-product-link', function() {
        // 判断
        if ($(this).parents('.box-recently-viewed').length > 0) {
          var reportType = WS.ui.collectionReportMap['clickRecentlyViewedProductCollection'];
        } else {
          var reportType = WS.ui.collectionReportMap['clickBottomProductCollection'];
        }
        // pos
        var index = $(this).parents('.ws-product-block').attr('stat-index');
        var curProductBlock = $(this).parents('.ws-product-block');
        // 商品信息
        // 处理sku里面的颜色
        var itemSku = curProductBlock.attr('stat-module-show-color');
        var itemCurSku = curProductBlock.attr('stat-module-show-selected-color');
        var color = itemCurSku != undefined && itemCurSku != 'undefined' ? itemCurSku.split('-')[1] : itemSku.split('-')[1];
        var param = {
          "products": {
            id: curProductBlock.attr('stat-module-show-id') + '',
            title: curProductBlock.attr('stat-module-show-title'),
            price: curProductBlock.attr('stat-module-show-price')/100,
            color: color,
          }
        };
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: reportType,
          ext2: JSON.stringify(param || []),
          ext3: `pos=${index}`,
          ext4: JSON.stringify(reportData || [])
        });
      });
    },

    /**
     * 有 banner 或短描述时：与 initScrollInteractive 一致，筛选条吸顶阶段会加上 white-bg-header；
     * 监听该类名，在 #collection-title 填入/清空集合名。仅 collection.title、无顶部模块时不初始化。
     */
    initCollectionStickyTitle: function () {
      var container = document.getElementById('collection-conatiner');
      if (!container || container.getAttribute('data-collection-sticky-title') !== 'true') return;

      var titleEl = document.getElementById('collection-title');
      var stickyBar = document.querySelector('.ws-collection-title-filter-box');
      if (!titleEl || !stickyBar) return;

      var titleText = container.getAttribute('data-collection-title');
      if (titleText == null) titleText = '';

      var lastPinned = null;

      function syncFromHeaderClass() {
        var isPinned = stickyBar.classList.contains('white-bg-header');
        console.log('isPinned', isPinned, titleText);
        if (isPinned === lastPinned) return;
        lastPinned = isPinned;
        titleEl.textContent = isPinned ? titleText : '';
      }

      syncFromHeaderClass();

      if (typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function () {
          syncFromHeaderClass();
        });
        mo.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
      } else {
        window.addEventListener('scroll', syncFromHeaderClass, { passive: true });
      }
    },

    /**
     * 上报方法
     */
    reportHandle: function (reportType, ext1, data = {}) {
      // 上报
      WS.stat({
        eid: reportType,
        ext1: ext1,
        ...data
      });
    }
  }

  

  /**
   * Collection Filters 弹窗（ws-cf）：打开/关闭动画、筛选与排序、See Results 跳转
   */
  function initCollectionFiltersModal() {
    var modals = document.querySelectorAll('.ws-cf');
    modals.forEach(function(el) {
      if (el.getAttribute('data-ws-cf-inited')) return;
      el.setAttribute('data-ws-cf-inited', '1');
      var overlay = el.querySelector('[data-ws-cf-close]');
      var closeBtn = el.querySelector('.ws-cf__close');
      var panel = el.querySelector('.ws-cf__panel');
      var titleEl = el.querySelector('.ws-cf__title');
      var sortSelect = el.querySelector('[data-ws-cf-sort-select]');
      var filterButton = document.getElementById('ws-list-filter-icon-btn');
      var sortButton = document.getElementById('ws-list-sort-icon-btn');
      var resultsStatus = document.querySelector('.ws-collection-results-status');
      var seeResults = el.querySelector('[data-ws-cf-see-results]');
      var clearBtn = el.querySelector('[data-ws-cf-clear]') || el.querySelector('.ws-cf__btn--secondary');
      var collectionUrl = el.getAttribute('data-collection-url') || '';
      var collectionId = el.getAttribute('data-collection-id') || '';
      var collectionHandle = getCollectionTrackHandle(el);
      var defaultTitle = titleEl ? (titleEl.getAttribute('data-ws-cf-default-title') || 'Collection Filters') : 'Collection Filters';
      var isDesktop = function() { return window.matchMedia && window.matchMedia('(min-width: 750px)').matches; };
      var sortPopover = null;
      var sortPopoverInner = null;
      var filterTouched = false;
      var sortTouched = false;
      var returnFocus = null;
      var inerted = [];
      var pendingResults = false;

      function announceResults(message) {
        if (resultsStatus) resultsStatus.textContent = message;
      }

      function setBackgroundInert() {
        for (var node = el; node && node.parentElement; node = node.parentElement) {
          Array.prototype.forEach.call(node.parentElement.children, function(sibling) {
            if (sibling === node || sibling.hasAttribute('inert')) return;
            sibling.setAttribute('inert', '');
            inerted.push(sibling);
          });
          if (node.parentElement === document.body) break;
        }
      }

      function restoreBackground() {
        inerted.forEach(function(node) { node.removeAttribute('inert'); });
        inerted = [];
      }

      function markResultsUpdating() {
        pendingResults = true;
        announceResults('Updating products');
      }

      var listing = document.getElementById('collection-conatiner');
      if (listing && typeof MutationObserver !== 'undefined') {
        var resultsTimer;
        new MutationObserver(function() {
          if (!pendingResults) return;
          clearTimeout(resultsTimer);
          resultsTimer = setTimeout(function() {
            var count = listing.querySelectorAll('.js-infinite-scroll-listing .ws-product-block').length;
            announceResults(count + (count === 1 ? ' product shown' : ' products shown'));
            pendingResults = false;
          }, 350);
        }).observe(listing, { childList: true, subtree: true });
      }

      function getStateStorageKey() {
        return collectionId ? ('ws-cf-state-' + collectionId) : 'ws-cf-state';
      }

      function ensureSortPopover() {
        if (sortPopover) return;
        sortPopover = document.createElement('div');
        sortPopover.className = 'ws-cf-sort-popover';
        sortPopover.setAttribute('aria-hidden', 'true');
        sortPopover.innerHTML = '<div class="ws-cf-sort-popover__inner"></div>';
        sortPopoverInner = sortPopover.querySelector('.ws-cf-sort-popover__inner');
        document.body.appendChild(sortPopover);

        sortPopover.addEventListener('change', function(e) {
          if (e.target.matches('[data-ws-cf-sort-popover-select]')) applySort(e.target.value);
        });
        sortPopover.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeSortPopover();
            if (sortButton) sortButton.focus();
          }
        });
        sortPopover.addEventListener('focusout', function() {
          setTimeout(function() {
            if (sortPopover && !sortPopover.contains(document.activeElement) && document.activeElement !== sortButton) closeSortPopover();
          }, 0);
        });
      }

      function openSortPopover(triggerEl) {
        ensureSortPopover();
        if (!sortPopoverInner) return;
        if (!sortSelect) return;
        sortPopoverInner.innerHTML = '<label for="ws-cf-sort-popover-select">Sort by</label><select id="ws-cf-sort-popover-select" data-ws-cf-sort-popover-select class="ws-cf__sort-select">' + sortSelect.innerHTML + '</select>';
        sortPopoverInner.querySelector('select').value = sortSelect.value;
        sortPopover.classList.add('is-open');
        sortPopover.setAttribute('aria-hidden', 'false');
        if (sortButton) sortButton.setAttribute('aria-expanded', 'true');
        positionSortPopover(triggerEl);
        sortPopoverInner.querySelector('select').focus();
      }

      function positionSortPopover(triggerEl) {
        if (!sortPopover || !triggerEl) return;
        var rect = triggerEl.getBoundingClientRect();
        // 先显示后计算宽度，右对齐到按钮
        var top = rect.bottom + window.scrollY + 8;
        sortPopover.style.top = top + 'px';
        sortPopover.style.left = '0px';
        var popRect = sortPopover.getBoundingClientRect();
        var left = rect.right + window.scrollX - popRect.width;
        // 防止溢出视口
        var minLeft = 12 + window.scrollX;
        var maxLeft = window.scrollX + window.innerWidth - popRect.width - 12;
        left = Math.max(minLeft, Math.min(left, maxLeft));
        sortPopover.style.left = left + 'px';
      }

      function closeSortPopover() {
        if (!sortPopover) return;
        sortPopover.classList.remove('is-open');
        sortPopover.setAttribute('aria-hidden', 'true');
        if (sortButton) sortButton.setAttribute('aria-expanded', 'false');
      }

      function toggleSortPopover(triggerEl) {
        ensureSortPopover();
        if (sortPopover && sortPopover.classList.contains('is-open')) closeSortPopover();
        else openSortPopover(triggerEl);
      }

      function setModalMode(mode) {
        var allGroups = el.querySelectorAll('.ws-cf__group');
        var sortGroup = el.querySelector('.ws-cf__group--sort');
        var dynamicContainer = el.querySelector('[data-ws-cf-dynamic]');
        if (!mode || mode === 'all') {
          allGroups.forEach(function(g) { g.style.display = ''; });
          if (dynamicContainer) dynamicContainer.style.display = '';
          return;
        }
        if (mode === 'filter') {
          if (sortGroup) sortGroup.style.display = 'none';
          if (dynamicContainer) dynamicContainer.style.display = '';
          allGroups.forEach(function(g) {
            if (g !== sortGroup) g.style.display = '';
          });
          return;
        }
        if (mode === 'sort') {
          if (dynamicContainer) dynamicContainer.style.display = 'none';
          allGroups.forEach(function(g) {
            g.style.display = g === sortGroup ? '' : 'none';
          });
        }
      }

      function openModal(mode, trigger) {
        var isSort = mode === 'sort';
        returnFocus = trigger || document.activeElement;
        filterTouched = false;
        sortTouched = false;
        el.classList.remove('ws-cf--hidden', 'ws-cf--closing');
        el.classList.add('ws-cf--open', 'ws-cf--opening');
        el.setAttribute('aria-hidden', 'false');
        if (filterButton) filterButton.setAttribute('aria-expanded', 'true');
        if (isSort && sortButton) sortButton.setAttribute('aria-expanded', 'true');
        setBackgroundInert();
        if (WS.ui.popupNoScrollHandle) {
          WS.ui.popupNoScrollHandle();
        } else {
          document.body.style.overflow = 'hidden';
        }
        if (panel) panel.classList.toggle('ws-cf__panel--sort-top', isSort);
        if (titleEl) titleEl.textContent = isSort ? 'Sort By' : defaultTitle;
        el.classList.toggle('ws-cf--sort-mode', isSort);
        if (isSort) el.setAttribute('data-ws-cf-mode', 'sort'); else el.removeAttribute('data-ws-cf-mode');
        setModalMode(mode || 'all');
        if (closeBtn) closeBtn.focus();
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { el.classList.remove('ws-cf--opening'); });
        });
      }
      function closeModal() {
        if (!el.classList.contains('ws-cf--open')) return;
        el.classList.add('ws-cf--closing');
        setTimeout(function() {
          if (panel) panel.classList.remove('ws-cf__panel--sort-top');
          el.classList.remove('ws-cf--sort-mode');
          el.removeAttribute('data-ws-cf-mode');
          el.classList.remove('ws-cf--open', 'ws-cf--closing');
          el.classList.add('ws-cf--hidden');
          el.setAttribute('aria-hidden', 'true');
          restoreBackground();
          if (filterButton) filterButton.setAttribute('aria-expanded', 'false');
          if (sortButton) sortButton.setAttribute('aria-expanded', 'false');
          if (WS.ui.popupRecoveryScrollHandle) {
            WS.ui.popupRecoveryScrollHandle();
          } else {
            document.body.style.overflow = '';
          }
          if (returnFocus && returnFocus.isConnected) returnFocus.focus();
        }, 320);
      }

      el.addEventListener('keydown', function(e) {
        if (!el.classList.contains('ws-cf--open')) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal();
          return;
        }
        if (e.key !== 'Tab') return;
        var items = Array.prototype.filter.call(el.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]'), function(item) {
          return item.getClientRects().length > 0;
        });
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !el.contains(document.activeElement))) {
          e.preventDefault(); first.focus();
        }
      });

      // 从 collectionPageParams 同步选中态到弹窗 UI（同会话内再次打开时显示已选）
      function syncSelectionFromParams() {
        var params = WS.getData('collectionPageParams') || {};
        var hasParams = (params.colorFilters && params.colorFilters.length) || (params.sizes && params.sizes.length) || (params.productTypes && params.productTypes.length) || (params.priceRange && params.priceRange.length) || params.orderBy;
        el.querySelectorAll('.ws-cf__pill--active').forEach(function(p) { p.classList.remove('ws-cf__pill--active'); });
        el.querySelectorAll('.ws-cf__color--active').forEach(function(p) { p.classList.remove('ws-cf__color--active'); });
        if (sortSelect && params.orderBy) sortSelect.value = params.orderBy;
        if (!hasParams) {
          el.querySelectorAll('.ws-cf__input').forEach(function(input) { input.checked = false; });
          return;
        }
        (params.colorFilters || []).forEach(function(f) {
          if (!f.param || !f.value) return;
          el.querySelectorAll('.ws-cf__color, .ws-cf__pill').forEach(function(opt) {
            if (opt.getAttribute('data-ws-cf-param') === f.param && opt.getAttribute('data-ws-cf-value') === f.value) {
              opt.classList.add(opt.classList.contains('ws-cf__color') ? 'ws-cf__color--active' : 'ws-cf__pill--active');
            }
          });
        });
        (params.sizes || []).forEach(function(val) {
          el.querySelectorAll('.ws-cf__pill[data-ws-cf-value]').forEach(function(p) {
            var pLower = (p.getAttribute('data-ws-cf-param') || '').toLowerCase();
            if (pLower.indexOf('size') >= 0 && p.getAttribute('data-ws-cf-value') === val) p.classList.add('ws-cf__pill--active');
          });
        });
        (params.productTypes || []).forEach(function(val) {
          el.querySelectorAll('.ws-cf__pill[data-ws-cf-value]').forEach(function(p) {
            var pLower = (p.getAttribute('data-ws-cf-param') || '').toLowerCase();
            if (pLower.indexOf('product') >= 0 && (pLower.indexOf('type') >= 0 || pLower.indexOf('product_type') >= 0) && p.getAttribute('data-ws-cf-value') === val) p.classList.add('ws-cf__pill--active');
          });
        });
        if (params.priceRange && params.priceRange.length) {
          var pr = params.priceRange[0];
          if (pr && pr.startPrice) {
            el.querySelectorAll('.ws-cf__pill[data-ws-cf-param="filter.v.price.gte"]').forEach(function(p) {
              if (p.getAttribute('data-ws-cf-value') === String(pr.startPrice)) p.classList.add('ws-cf__pill--active');
            });
          }
          if (pr && pr.endPrice) {
            el.querySelectorAll('.ws-cf__pill[data-ws-cf-param="filter.v.price.lte"]').forEach(function(p) {
              if (p.getAttribute('data-ws-cf-value') === String(pr.endPrice)) p.classList.add('ws-cf__pill--active');
            });
          }
        }
        el.querySelectorAll('.ws-cf__input').forEach(function(input) {
          input.checked = input.parentElement.classList.contains('ws-cf__pill--active') || input.parentElement.classList.contains('ws-cf__color--active');
        });
      }

      function getSortTrackType(sortVal) {
        var active = sortSelect && Array.prototype.find.call(sortSelect.options, function(option) { return option.value === sortVal; });
        return getTrackText(active) || sortVal || '';
      }

      function applySort(sortVal) {
        if (sortSelect) sortSelect.value = sortVal;

        var params = WS.getData('collectionPageParams') || {};
        params.orderBy = sortVal;
        WS.setData('collectionPageParams', params);
        markResultsUpdating();
        WS.ui.infiniteScroll.resetShopifyCollection();
        trackCollectionClick('sort_items', {
          collectionHandle: collectionHandle,
          sortType: getSortTrackType(sortVal)
        });

        closeSortPopover();
        if (sortButton && !el.classList.contains('ws-cf--open')) sortButton.focus();
        if (el.classList.contains('ws-cf--open')) {
          closeModal();
          document.body.style.overflow = '';
          WS.ui.popupRecoveryScrollHandle && WS.ui.popupRecoveryScrollHandle();
        }
        var $listing = $('#collection-conatiner').find('.js-infinite-scroll-listing');
        $listing.length && $listing.trigger('ws-trigger-load');
      }

      el.addEventListener('change', function(e) {
        if (e.target === sortSelect) {
          sortTouched = true;
          if (el.getAttribute('data-ws-cf-mode') === 'sort') applySort(sortSelect.value);
          return;
        }
        if (!e.target.matches('.ws-cf__input')) return;
        var opt = e.target.closest('.ws-cf__pill, .ws-cf__color');
        if (!opt) return;
        opt.classList.toggle(opt.classList.contains('ws-cf__color') ? 'ws-cf__color--active' : 'ws-cf__pill--active', e.target.checked);
        filterTouched = true;
      });

      if (overlay) overlay.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (seeResults) seeResults.addEventListener('click', function() {
        var params = WS.getData('collectionPageParams') || {};
        params.colorFilters = [];
        params.sizes = [];
        params.productTypes = [];
        params.priceRange = [];
        params.orderBy = '';
        params.orderBy = sortSelect ? sortSelect.value : '';
        el.querySelectorAll('.ws-cf__pill--active, .ws-cf__color--active').forEach(function(opt) {
            var param = opt.getAttribute('data-ws-cf-param');
            var val = opt.getAttribute('data-ws-cf-value');
            if (param && val) {
              var p = param.toLowerCase();
              if (p.indexOf('color') >= 0) {
                params.colorFilters.push({ param: param, value: val });
              } else if (p.indexOf('size') >= 0) {
                params.sizes.push(val);
              } else if (p.indexOf('product') >= 0 && (p.indexOf('type') >= 0 || p.indexOf('product_type') >= 0)) {
                params.productTypes.push(val);
              } else if (param === 'filter.v.price.gte' || param === 'filter.v.price.lte') {
                var pr = params.priceRange[0] || { currency: (WS.site && WS.site.symbol) || '', startPrice: '', endPrice: '' };
                if (param === 'filter.v.price.gte') pr.startPrice = val;
                else pr.endPrice = val;
                params.priceRange = [pr];
              }
            }
        });
        if (params.priceRange.length && (!params.priceRange[0].startPrice && !params.priceRange[0].endPrice)) {
          params.priceRange = [];
        }
        var filterTrackData = getCollectionFilterTrackingData(params);
        if (filterTouched && hasCollectionFilterTrackingData(filterTrackData)) {
          filterTrackData.collectionHandle = collectionHandle;
          trackCollectionClick('filter_items', filterTrackData);
        }
        if (sortTouched && params.orderBy) {
          trackCollectionClick('sort_items', {
            collectionHandle: collectionHandle,
            sortType: getSortTrackType(params.orderBy)
          });
        }
        WS.setData('collectionPageParams', params);
        markResultsUpdating();
        WS.ui.infiniteScroll.resetShopifyCollection();
        closeModal();
        document.body.style.overflow = '';
        WS.ui.popupRecoveryScrollHandle && WS.ui.popupRecoveryScrollHandle();
        var $listing = $('#collection-conatiner').find('.js-infinite-scroll-listing');
        $listing.length && $listing.trigger('ws-trigger-load');
      });

      // 清空筛选：移除选中状态，重置为无筛选，局部更新列表
      if (clearBtn) clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        try {
          window.sessionStorage && sessionStorage.removeItem(getStateStorageKey());
        } catch (err) {}
        el.querySelectorAll('.ws-cf__pill--active').forEach(function(p) { p.classList.remove('ws-cf__pill--active'); });
        el.querySelectorAll('.ws-cf__color--active').forEach(function(p) { p.classList.remove('ws-cf__color--active'); });
        el.querySelectorAll('.ws-cf__input').forEach(function(input) { input.checked = false; });
        WS.setData('collectionPageParams', {});
        markResultsUpdating();
        WS.ui.infiniteScroll.resetShopifyCollection();
        closeModal();
        document.body.style.overflow = '';
        WS.ui.popupRecoveryScrollHandle && WS.ui.popupRecoveryScrollHandle();
        var $listing = $('#collection-conatiner').find('.js-infinite-scroll-listing');
        $listing.length && $listing.trigger('ws-trigger-load');
      });

      document.addEventListener('click', function openTrigger(e) {
        var filterTrigger = e.target.closest('#ws-list-filter-icon-btn') || e.target.closest('.ws-list-filter-icon-btn') || e.target.closest('[data-collection-filters-open="filter"]');
        var sortTrigger = e.target.closest('#ws-list-sort-icon-btn') || e.target.closest('.ws-list-sort-icon-btn') || e.target.closest('[data-collection-filters-open="sort"]');
        var genericTrigger = e.target.closest('[data-collection-filters-open]') || e.target.closest('.ls-list-filter-icon-btn');

        // PC：sort 用按钮下拉层，不打开底部弹窗
        if (sortPopover && sortPopover.classList.contains('is-open')) {
          var inPopover = sortPopover.contains(e.target);
          var onSortBtn = sortTrigger && !el.contains(sortTrigger);
          if (!inPopover && !onSortBtn) closeSortPopover();
        }

        if (filterTrigger && !el.contains(filterTrigger)) {
          trackCollectionClick('filter_icon', { collectionHandle: collectionHandle });
          openModal('filter', filterTrigger);
          collectionPageFn.handleFilterData(1, function() {
            syncSelectionFromParams();
          });
        } else if (sortTrigger && !el.contains(sortTrigger)) {
          trackCollectionClick('sort_icon', { collectionHandle: collectionHandle });
          if (isDesktop()) {
            toggleSortPopover(sortTrigger);
            collectionPageFn.handleFilterData(1, function() {
              syncSelectionFromParams();
              if (sortPopover && sortPopoverInner && sortPopover.classList.contains('is-open')) {
                var popoverSelect = sortPopoverInner.querySelector('select');
                if (popoverSelect && sortSelect) popoverSelect.value = sortSelect.value;
              }
            });
            // sort 下拉打开后，跟随滚动/缩放重新定位
            if (sortPopover && sortPopover.classList.contains('is-open')) positionSortPopover(sortTrigger);
          } else {
            openModal('sort', sortTrigger);
            collectionPageFn.handleFilterData(1, function() {
              syncSelectionFromParams();
            });
          }
        } else if (genericTrigger && !el.contains(genericTrigger)) {
          trackCollectionClick('filter_icon', { collectionHandle: collectionHandle });
          openModal('all', genericTrigger);
          collectionPageFn.handleFilterData(1, function() {
            syncSelectionFromParams();
          });
        }
      });

      // PC sort 下拉：窗口变化时重新定位
      window.addEventListener('scroll', function() {
        if (!sortPopover || !sortPopover.classList.contains('is-open')) return;
        var btn = document.getElementById('ws-list-sort-icon-btn');
        if (btn) positionSortPopover(btn);
      }, { passive: true });
      window.addEventListener('resize', function() {
        if (!sortPopover || !sortPopover.classList.contains('is-open')) return;
        var btn = document.getElementById('ws-list-sort-icon-btn');
        if (btn) positionSortPopover(btn);
      });
    });
  }

  // 初始化方法
  function init() {
    collectionPageFn.updateCollectionCount();
    // 初始化列表前先同步 URL 参数，避免首次加载丢失价格筛选和排序。
    initCollectionParamsFromUrl();
    // 上报参数
    reportData = {
      id: $('.ws-collection-modelbox').attr('collectionid'),
      name: $('.ws-collection-modelbox').attr('handle')
    };
    // 事件集合方法
    collectionPageFn.bindEvent();
    collectionPageFn.initShortDescriptionHandle();
    collectionPageFn.initSubcollectionsScrollbar();
    // Collection Filters 弹窗（ws-cf）
    initCollectionFiltersModal();

    collectionPageFn.initCollectionStickyTitle();

    setTimeout(() => {
      WS.ui.prefetchUrls(window.WS_COLLECTION_PREFETCH_URLS, 'prefetch');

      WS.ui.initScrollToTop();
    }, 300);
  }
  
  init();
  // 上报可交互
  WS.ui.reportInteractiveTime();

  WS.ui.collectionPageFn = {
    initCollectionFiltersModal: initCollectionFiltersModal
  };

})();
